import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DeliveryType, ReceiptType } from '@/types/ListEntry';
import { useLegacyApi } from '@/hooks/useLegacyApi';

export interface SelectionMutationProps {
  deliveryType: DeliveryType;
  receiptType: ReceiptType | null;
}

export default function useSelection(entryId: number) {
  const queryClient = useQueryClient();
  const { apiClient } = useLegacyApi();

  return useMutation({
    mutationFn: ({ deliveryType, receiptType }: SelectionMutationProps) =>
      apiClient.post(`/api/net-auctions/${entryId}/selection`, {
        deliveryType,
        receiptType,
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['currentUser', 'entries', entryId] }),
  });
}
